import {
  MdArticle,
  MdDashboard,
  MdOutlineAdminPanelSettings,
  MdOutlineReviews,
} from "react-icons/md";
import { FaBlog, FaQuestionCircle, FaTags, FaUsers } from "react-icons/fa";
import { BsBoxSeam } from "react-icons/bs";
import { BiCategory, BiGitBranch, BiPackage } from "react-icons/bi";
import { AiOutlinePicture } from "react-icons/ai";
import { GrContact } from "react-icons/gr";
import { PiShieldWarningBold } from "react-icons/pi";
import { IoNotifications } from "react-icons/io5";
import { RiTeamFill } from "react-icons/ri";
import { BsPrescription2 } from "react-icons/bs";
import { Briefcase, FileText, Settings } from "lucide-react";

export const sidebarItems = [
  {
    id: 1,
    label: "Dashboard",
    parent_id: null,
    icon: <MdDashboard size={20} />,
    module: "dashboard",
    order_index: 1,
    url: "/admin/dashboard",
  },
  {
    id: 2,
    label: "Patients",
    parent_id: null,
    icon: <FaUsers size={20} />,
    module: "patients",
    order_index: 2,
    url: "/admin/patients",
  },
  {
    id: 3,
    label: "Individual Test",
    parent_id: null,
    icon: <BiCategory size={20} />,
    module: "individualTest",
    order_index: 3,
    url: "/admin/testlist",
  },
  {
    id: 4,
    label: "Package Test",
    parent_id: null,
    icon: <BiPackage size={20} />,
    module: "packageTest",
    order_index: 4,
    url: "/admin/profileTest",
  },
  {
    id: 5,
    label: "Bookings",
    parent_id: null,
    icon: <BsBoxSeam size={20} />,
    module: "bookings",
    order_index: 5,
    url: "/admin/bookings",
  },
  {
    id: 6,
    label: "Banners",
    parent_id: null,
    icon: <AiOutlinePicture size={20} />,
    module: "banners",
    order_index: 6,
    url: "/admin/banners",
  },
  {
    id: 7,
    label: "Admin List",
    parent_id: null,
    icon: <MdOutlineAdminPanelSettings size={20} />,
    module: "adminList",
    order_index: 7,
    url: "/admin/admin-list",
  },
  {
    id: 8,
    label: "Testimonial",
    parent_id: null,
    icon: <MdOutlineReviews size={20} />,
    module: "testimonial",
    order_index: 8,
    url: "/admin/testimonial",
  },
  {
    id: 9,
    label: "Enquiry",
    parent_id: null,
    icon: <GrContact size={20} />,
    module: "enquiry",
    order_index: 9,
    url: "/admin/enquiry",
  },
  {
    id: 10,
    label: "FAQ",
    parent_id: null,
    icon: <FaQuestionCircle size={20} />,
    module: "faq",
    order_index: 10,
    url: "/admin/faq",
  },
  {
    id: 11,
    label: "Complaints",
    parent_id: null,
    icon: <PiShieldWarningBold size={20} />,
    module: "issues&complaints",
    order_index: 11,
    url: "/admin/issues",
  },
  {
    id: 12,
    label: "Push Notifications",
    parent_id: null,
    icon: <IoNotifications size={20} />,
    module: "notification",
    order_index: 13,
    url: "/admin/notifications",
  },
  {
    id: 13,
    label: "Team",
    parent_id: null,
    icon: <RiTeamFill size={20} />,
    module: "team",
    order_index: 14,
    url: "/admin/team",
  },
  {
    id: 14,
    label: "Prescription",
    parent_id: null,
    icon: <BsPrescription2 size={20} />,
    module: "prescription",
    order_index: 15,
    url: "/admin/prescription",
  },
  {
    id: 15,
    label: "Branches",
    parent_id: null,
    icon: <BiGitBranch size={20} />,
    module: "branches",
    order_index: 15,
    url: "/admin/branches",
  },
  {
    id: 16,
    label: "Settings",
    parent_id: null,
    icon: <Settings size={20} />,
    module: "settings",
    order_index: 16,
    url: "/admin/settings",
  },
  {
    id: 17,
    label: "Careers",
    parent_id: null,
    icon: <Briefcase size={20} />,
    module: "careers",
    order_index: 17,
    url: "/admin/career-applications",
  },
  {
    id: 18,
    label: "Blogs",
    parent_id: null,
    icon: <FaBlog size={20} />,
    module: "blogs",
    order_index: 18,
    url: "",
    children: [
      {
        id: 19,
        label: "Blogs",
        parent_id: 18,
        icon: <MdArticle size={20} />,
        module: "blogs",
        order_index: 1,
        url: "/admin/blogs",
      },
      {
        id: 20,
        label: "Categories",
        parent_id: 18,
        icon: <BiCategory size={20} />,
        module: "blogs",
        order_index: 2,
        url: "/admin/blog-category",
      },
      {
        id: 21,
        label: "Tags",
        parent_id: 18,
        icon: <FaTags size={20} />,
        module: "blogs",
        order_index: 3,
        url: "/admin/blog-tags",
      },
    ],
  },
  {
    id: 22,
    label: "Services",
    parent_id: null,
    icon: <MdArticle size={20} />,
    module: "services",
    order_index: 19,
    url: "/admin/service-page",
  },
  {
    id: 23,
    label: "logs",
    parent_id: null,
    icon: <FileText size={20} />,
    module: "careers",
    order_index: 22,
    url: "/admin/logs",
  },

  // {
  //   id: 5,
  //   label: "Teachers",
  //   parent_id: null,
  //   icon: <LiaChalkboardTeacherSolid size={20} />,
  //   module: "teacher",
  //   order_index: 5,
  //   url: "",
  //   children: [
  //     {
  //       id: 6,
  //       label: "All Teachers",
  //       parent_id: 5,
  //       icon: <PiChalkboardTeacher size={20} />,
  //       module: "teachers",
  //       order_index: 6,
  //       url: "/admin/teachers",
  //     },
  //     {
  //       id: 7,
  //       label: "Class Teachers",
  //       parent_id: 5,
  //       icon: <GiTeacher size={20} />,
  //       module: "class-teachers",
  //       order_index: 7,
  //       url: "/admin/class-teachers",
  //     },
  //   ],
  // },
];
